<template>
    <b-card v-if="!fromParentLogin || (fromParentLogin && show_basic_info_only)">
        <div class="section-container">
            <b-row align-v="center">
                <b-col md="12">
                    <h5 class="text-uppercase text-info font-weight-bold" style="display: flex; align-items: center">
                        <i class="fas fa-user-shield mr-1"></i>GUARDIAN/PARENT DETAILS
                    </h5>
                </b-col>
            </b-row>

            <b-row v-if="guardians && guardians.length > 0" align-v="center" class="mb-3">
                <b-col md="12">
                    <table class="table table-striped table-bordered">
                        <thead class="thead-dark text-left">
                            <tr>
                                <th class="font-weight-bold">Name</th>
                                <th class="font-weight-bold">Relationship</th>
                                <th class="font-weight-bold">Education</th>
                                <th class="font-weight-bold">Occupation</th>
                                <th class="font-weight-bold">Annual Income</th>
                                <th class="font-weight-bold">Mobile Number</th>
                                <th class="font-weight-bold">Email</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(guardian, gIndex) in guardians" :key="gIndex">
                                <td>{{ guardian.name }}</td>
                                <td>{{ capitalizeFirstLetter(guardian.relationship) }}</td>
                                <td>{{ guardian.education }}</td>
                                <td>{{ guardian.occupation }}</td>
                                <td>{{ guardian.annual_income }}</td>
                                <td>{{ guardian.phone_number }}</td>
                                <td>{{ guardian.email }}</td>
                            </tr>
                        </tbody>
                    </table>
                </b-col>
            </b-row>
        </div>
    </b-card>
</template>

<script>
export default {
    name: "GuardianParentDetails",
    props: {
        guardians: {
            type: Array,
            default: () => []
        },
        fromParentLogin: {
            type: Boolean,
            default: false
        },
        show_basic_info_only: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        capitalizeFirstLetter(string) {
            if (!string) return '';
            return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
        }
    }
};
</script>
<style scoped>
.section-container {
    padding: 14px;
    background-color: #f9f9f9;
    border-radius: 0px;
}

.capitalize {
    text-transform: capitalize;
}
</style>